'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002457 from "./presto.-Credentials-View$$anon$57.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002458 from "./presto.-Credentials-View$$anon$58.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002459 from "./presto.-Credentials-View$$anon$59.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002460 from "./presto.-Credentials-View$$anon$60.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002461 from "./presto.-Credentials-View$$anon$61.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$56(outer) {
  this.aHc = null;
  this.aHa = null;
  this.aHb = false;
  this.aH8 = null;
  this.aH9 = false;
  this.aHd = false;
  this.aHe = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aHc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$56 as $c_Lpresto_CredentialsView$$anon$56 };
$p = $c_Lpresto_CredentialsView$$anon$56.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$56;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$56() {
}
export { $h_Lpresto_CredentialsView$$anon$56 as $h_Lpresto_CredentialsView$$anon$56 };
$h_Lpresto_CredentialsView$$anon$56.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aHc;
});
$p.t = (function() {
  if ((!this.aHb)) {
    this.aHa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySeed", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByTfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySiteAndGroup", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByDocument", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aHb = true;
  }
  return this.aHa;
});
$p.ag = (function() {
  if ((!this.aH9)) {
    this.aH8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002457.$c_Lpresto_CredentialsView$$anon$57(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002458.$c_Lpresto_CredentialsView$$anon$58(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002459.$c_Lpresto_CredentialsView$$anon$59(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002460.$c_Lpresto_CredentialsView$$anon$60(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aH9 = true;
  }
  return this.aH8;
});
$p.v = (function() {
  if ((!this.aHe)) {
    this.aHd = true;
    this.aHe = true;
  }
  return this.aHd;
});
$p.ad6 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002461.$c_Lpresto_CredentialsView$$anon$61().afc(a), a);
});
$p.ae = (function(a) {
  return this.ad6(a);
});
var $d_Lpresto_CredentialsView$$anon$56 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$56, "presto.CredentialsView$$anon$56", ({
  G5: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$56 as $d_Lpresto_CredentialsView$$anon$56 };
//# sourceMappingURL=presto.-Credentials-View$$anon$56.js.map
